/**
 * Core
 */
import Vue from 'vue';
import Router from 'vue-router';
import RedirectUtils from './utils.js';

/**
 * Views
 */

import Customers from './../views/Customers.vue';
import Errors from './../views/Errors.vue';
import Home from './../views/Home.vue';
import Login from './../views/Login.vue';
import Logout from './../views/Logout.vue';
import MyAccount from './../views/MyAccount.vue';
import Orders from './../views/Orders.vue';
import Prices from './../views/Prices.vue';
import Settlements from './../views/Settlements.vue';
import Splashscreen from './../views/SplashScreen.vue';
import Translations from './../views/Translations.vue';
import Users from './../views/Users.vue';

/**
 * Subviews
 */
import CustomerNew from './../components/customers/CustomerNew.vue';
import CustomerEdit from './../components/customers/CustomerEdit.vue';
import NoPermissions from './../views/NoPermissions.vue';
import PriceNew from './../components/prices/PriceNew.vue';
import PriceEdit from './../components/prices/PriceEdit.vue';
import RequestWrapper from './../components/orders/RequestWrapper.vue';
import TranslationEdit from './../components/translations/TranslationEdit.vue';
import UserNew from './../components/users/UserNew.vue';
import UserEdit from './../components/users/UserEdit.vue';


/**
 * Helpers
 */
import SanitizeUtils from './../utils/SanitizeUtils';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/logowanie',
      component: Login,
      name: 'Logowanie',
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/wyloguj',
      component: Logout,
      name: 'Wyloguj'
    },
    {
      path: '/wczytywanie',
      component: Splashscreen,
      name: 'Splashscreen'
    },
    {
      path: '/',
      redirect: '/kokpit'
    },
    {
      path: '/kokpit',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (window.crmApp && !window.crmApp.hasPermissions('home')) {
          next('/zamowienia');
          return;
        }

        RedirectUtils.permissionsCheck('home', next);
      }
    },
    {
      path: '/klienci',
      component: Customers,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_customers', next);
      }
    },
    {
      path: '/klienci/nowy',
      component: CustomerNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_customers', next);
      }
    },
    {
      path: '/klienci/edycja/:id',
      component: CustomerEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_customers', next);
      }
    },
    {
      path: '/moje-konto',
      component: MyAccount,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('profile', next);
      }
    },
    {
      path: '/zamowienia',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia/nowe/',
      component: RequestWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia/nowe/z-koszyka',
      component: RequestWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia/podglad/:id',
      component: RequestWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty/nowa/',
      component: RequestWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty/edycja/:id',
      component: RequestWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/rozliczenia',
      component: Settlements,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settlements', next);
      }
    },
    {
      path: '/uzytkownicy',
      component: Users,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/uzytkownicy/nowy',
      component: UserNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/uzytkownicy/edycja/:id',
      component: UserEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/tlumaczenia',
      component: Translations,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/tlumaczenia/edycja/:id',
      component: TranslationEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/cenniki/produkty',
      component: Prices,
      meta: {
        type: 'products'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/produkty/nowy',
      component: PriceNew,
      meta: {
        type: 'products'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/produkty/edycja/:id',
      component: PriceEdit,
      meta: {
        type: 'products'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/zdobienia',
      component: Prices,
      meta: {
        type: 'services'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/zdobienia/nowy',
      component: PriceNew,
      meta: {
        type: 'services'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/zdobienia/edycja/:id',
      component: PriceEdit,
      meta: {
        type: 'services'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/setup',
      component: Prices,
      meta: {
        type: 'setups'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/setup/nowy',
      component: PriceNew,
      meta: {
        type: 'setups'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/cenniki/setup/edycja/:id',
      component: PriceEdit,
      meta: {
        type: 'setups'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('partner_users', next);
      }
    },
    {
      path: '/404',
      component: Errors
    },
    {
      path: '/brak-uprawnien',
      component: NoPermissions
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});

router.beforeEach((to, from, next) => {
  let notLoggedInRoutes = [
    'Logowanie',
    'Wyloguj'
  ];

  if (notLoggedInRoutes.indexOf(to.name) === -1 && !SanitizeUtils.getToken()) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next({ name: 'Logowanie' });
    return;
  }

  if (notLoggedInRoutes.indexOf(to.name) !== -1) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next();
    return;
  }

  if (!window.crmApp) {
    setTimeout(() => {
      next({
        name: 'Splashscreen',
        params: {
          nextRoute: to.path
        }
      });

      let splashscreenHtml = document.querySelector('#splashscreen');

      if (splashscreenHtml) {
        splashscreenHtml.parentNode.removeChild(splashscreenHtml);
      }
    }, 0);

    return;
  }

  if (from && from.path) {
    sessionStorage.setItem('headwear-crm-previous-view', from.path);
  }

  next();
});

export default router;
